<template>
  <el-container>
    <!--顶部导航 -->
    <el-header :class="linkActive == '0' && bannerData.length != 0 && scrollHeight < 500?'bgblack':'bgWhite'">
      <el-row class="centerContainer h100">
        <el-col :data-df="scrollHeight" :xl="3" :lg="3" :md="3" :sm="3" :xs="3" class="h100">
          <el-image v-if="linkActive == '0' && bannerData.length != 0 && scrollHeight < 500"
            :src="require('@/assets/images/logo.png')" style="height:.8rem;" :fit="'contain'" />
          <el-image v-else :src="require('@/assets/images/logo1.png')" style="height:.8rem;" :fit="'contain'" />
        </el-col>
        <el-col v-if="linkActive == '0' && bannerData.length != 0 && scrollHeight < 500" :xl="19" :lg="17" :md="17"
          :sm="17" :xs="17" class="h100">
          <ul class="navBox h100">
            <li :class="linkActive == index?'active index':'index'" v-for="(item, index) in navArr" :key="index"
              @click="Jump(item,index)">
              <span>{{ item.name }}</span>
              <!-- <el-dropdown v-else>
                <span>{{item.name}}</span>
                <el-dropdown-menu slot="dropdown" placement="bottom" class="mxzbox">
                  <el-dropdown-item class="mxzitem">
                    <div @click="topage('/principalforum')">校长论坛</div>
                  </el-dropdown-item>
                  <el-dropdown-item class="mxzitem">
                    <div @click="topage('/principal')">名校长工作室</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
            </li>
          </ul>
        </el-col>
        <el-col v-else :xl="19" :lg="17" :md="17" :sm="17" :xs="17" class="h100">
          <ul class="navBox h100">
            <li :class="linkActive == index?'active':''" v-for="(item, index) in navArr" :key="index"
              @click="Jump(item,index)">
               <span>{{ item.name }}</span>
             <!-- <el-dropdown v-else>
                <span>{{item.name}}</span>
                <el-dropdown-menu slot="dropdown" placement="bottom" class="mxzbox">
                  <el-dropdown-item class="mxzitem">
                    <div @click="topage('/principalforum')">校长论坛</div>
                  </el-dropdown-item>
                  <el-dropdown-item class="mxzitem">
                    <div @click="topage('/principal')">名校长工作室</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
            </li>
          </ul>
        </el-col>
        <el-col v-if="linkActive == '0' && bannerData.length != 0 && scrollHeight < 500" :xl="2" :lg="4" :md="4" :sm="4"
          :xs="4" class="h100">
          <div class="loginBox h100">
            <!-- <el-input class="inputBox" @keyup.enter.native="search" v-model="searchVal" suffix-icon="el-icon-search">
            </el-input> -->
            <div class="loginRight topWhite">
              <el-dropdown>
                <div class="hand lingdang el-icon-bell" @click="toxxlist()">
                  <div class="messageNum" v-if="messageList.length != 0">
                    {{messageNum.length || 0}}
                  </div>
                </div>
                <el-dropdown-menu slot="dropdown" placement="bottom" class="ownBox1" v-if="messageList.length != 0">
                  <el-dropdown-item class="ownitem" v-for="(item,index) in messageList" :key="index">
                    <div class="itemtitle" @click="todetaillist(item)">{{item.content}}!</div>
                    <div class="itemtime" @click="todetaillist(item)">
                      {{item.sendTime}}
                    </div>
                  </el-dropdown-item>
                  <div class="showmore" @click="$router.push('/studyMessageList')">
                    更多 > >
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
              <div class="avatarBox" v-if="isLogin">
                <div class="ownBox">
                  <div class="ownName">{{userName}}</div>
                  <div @click="toabout" class="ownList hand" v-if="bqInfo.aboutus == 'true'">关于我们</div>
                  <div @click="tohistory" class="ownList hand" v-if="bqInfo.history == 'true'">发展历程</div>
                  <div @click="toOwn" class="ownList hand">个人中心</div>
                  <div @click="outLogin" class="ownList hand">退出登录</div>
                </div>
                <img :src="userAvatar" style="width:.3rem;height: .3rem;border-radius:50%;" />
              </div>
              <div v-if="!isLogin" @click="login(1)" class="hand" style="padding-right:.08rem;">登录</div>
              <!-- <div v-if="!isLogin" @click="login(2)" class="hand">注册</div> -->
            </div>
          </div>
        </el-col>
        <el-col v-else :xl="2" :lg="4" :md="4" :sm="4" :xs="4" class="h100">
          <div class="loginBox h100">
            <!-- <el-input style="width: 200px;height:30px;" @keyup.enter.native="search" v-model="searchVal"
              suffix-icon="el-icon-search">
            </el-input> -->
            <div class="loginRight">
              <el-dropdown>
                <div class="hand lingdang el-icon-bell" @click="toxxlist()">
                  <div class="messageNum" v-if="messageList.length != 0">
                    {{messageNum || 0}}
                  </div>
                </div>
                <el-dropdown-menu slot="dropdown" placement="bottom" class="ownBox1" v-if="messageList.length != 0">
                  <el-dropdown-item class="ownitem" v-for="(item,index) in messageList" :key="index">
                    <div class="itemtitle" @click="todetaillist(item)">{{item.content}}!</div>
                    <div class="itemtime" @click="todetaillist(item)">
                      {{item.sendTime}}
                    </div>
                  </el-dropdown-item>
                  <div class="showmore" @click="$router.push('/studyMessageList')">
                    更多 > >
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
              <div class="avatarBox" v-if="isLogin">
                <div class="ownBox">
                  <div class="ownName">{{userName}}</div>
                  <div @click="toabout" class="ownList hand" v-if="bqInfo.aboutus == 'true'">关于我们</div>
                  <div @click="tohistory" class="ownList hand" v-if="bqInfo.history == 'true'">发展历程</div>
                  <div @click="toOwn" class="ownList hand">个人中心</div>
                  <div @click="outLogin" class="ownList hand">退出登录</div>
                </div>
                <img :src="userAvatar" style="width:.3rem;height: .3rem;border-radius:50%;" />
              </div>
              <div v-if="!isLogin" @click="login(1)" class="hand" style="padding-right:.08rem;">登录</div>
              <!-- <div v-if="!isLogin" @click="login(2)" class="hand">注册</div> -->
            </div>
          </div>
        </el-col>
      </el-row>
    </el-header>
    <!-- <login v-if="loginShow" @loginChange="loginChange" :registerShow="registerShow"/> -->
    <login @loginChange="loginChange" :registerShow="registerShow" />
    <router-view></router-view>
    <!-- 底部 -->
    <el-footer class="footer">
      <el-row class="centerContainer">
        <!-- <el-col class="footerBox" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <div class="li" style="cursor: pointer;" v-for="(item, index) in footerArr" :key="index"
            @click="tolist(item,index)">{{ item.name }}</div>
        </el-col> -->
        <el-col :span="15" :offset="1" style="border-right:.01rem solid rgb(100,103,106);">

          <div class="div" style="text-align:left">
            <span class="huiZi">平台备案：<a style="color: #6e6e6e;" href="https://beian.miit.gov.cn/" target="_blank">{{bqInfo.filings}}</a></span>
          </div>
          <div class="div" style="text-align:left">
            <span class="huiZi">平台邮箱：{{bqInfo.email}}</span>
          </div>
          <div class="div" style="text-align:left">
            <span class="huiZi">服务电话：{{bqInfo.mobile}}</span>
          </div>
          <div class="div" style="text-align:left">
            <span class="baiZi">版权所有：{{bqInfo.copyright}}</span>
          </div>
        </el-col>
        <el-col :span="8" style="padding-left:.8rem;padding-top:.2rem;box-sizing:boder-box;padding-right:.5rem">
          <div style="display:flex;align-items:center;justify-content:space-between">
            <div style="display:flex;flex-direction: column;align-items:center">
              <img src="../assets/images/msy-gzh.jpg" alt="" style="width:1rem;height:1rem;margin-bottom:.1rem">
              <span style="color:#fff">{{bqInfo.gzh}}</span>
            </div>
            <div style="display:flex;flex-direction: column;align-items:center;">
              <img src="../assets/images/msy-xcx.jpg" alt="" style="width:1rem;height:1rem;margin-bottom:.1rem">
              <span style="color:#fff">{{bqInfo.xcx}}</span>
            </div>
            <div style="display:flex;flex-direction: column;align-items:center;">
              <img src="../assets/images/msy-sph.jpg" alt="" style="width:1rem;height:1rem;margin-bottom:.1rem">
              <span style="color:#fff">{{bqInfo.sph}}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
  import login from "../LoginRegist/login"; //引入组件
  import { getToken, removeToken } from '@/utils/auth'
  import { getInfo, getTeacherInfo, logout } from '@/api/login'
  import * as studyApi from '@/api/study'
  import { getBannerList } from '@/api/home';
  import {
    getGroupDetail,
    addStudioShenDetail,
    addStudioShenAgree,
  } from '@/api/study/studyGroup'
  export default {
    name: "HelloWorld",
    props: {
      scrollHeight: {
        type: Number,
        default: 0
      },
    },
    components: { login },
    watch: {
      $route(to, from) {
        console.log(to.path, 5555555555)
        if (getToken()) {
          this.getList();
          this.getmsgNum()
        }
        this.getbqInfo();
        if (to.path == '/') {
          this.linkActive = 0;
        }
        // else if (to.path == '/notice' || to.path == '/noticeDetail') {
        //   this.linkActive = 1;
        // } 
        else if (to.path == '/themeTeacher' || to.path == '/themeDetail') {
          this.linkActive = 1;
        } else if (to.path == '/specialZuo' || to.path == '/zhtiDetail') {
          this.linkActive = 2;
        } else if (to.path == '/jiaoPeixun' || to.path == '/jiaocaiDetail') {
          this.linkActive = 7;
        } else if (to.path == '/service' || to.path == '/serviceDetail') {
          this.linkActive = 8;
        } else if (to.path == '/teKecheng' || to.path == '/teseDetail') {
          this.linkActive = 9;
        }
        //  else if (to.path.indexOf('/keliShow') >= 0) {
        //   this.linkActive = 6;
        // }
        else if (to.path.indexOf('/team') >= 0) {
          this.linkActive = 10;
        } else if (to.path.indexOf('/school') >= 0) {
          this.linkActive = 11;
        } else if (to.path.indexOf('/teacher') >= 0) {
          this.linkActive = 4;
        } else if (to.path.indexOf('study') >= 0) {
          this.linkActive = 12;
        } else if (to.path.indexOf('/qyjy') >= 0) {
          this.linkActive = 3;
        } else if (to.path.indexOf('/resourceCenter') >= 0 || to.path.indexOf('/resourceDetail') >= 0 || to.path.indexOf('/resourceVideoDetail') >= 0) {
          this.linkActive = 13;
        } else if (to.path.indexOf('/manage') >= 0) {
          this.linkActive = 14;
        } else if (to.path.indexOf('/studyMessageList') >= 0) {
          this.linkActive = 15;
        } else if (to.path.indexOf('/principal') >= 0) {
          this.linkActive = 5
        } else if (to.path.indexOf('/zeroCarbon') >= 0) {
          this.linkActive = 6
        }
        else {
          this.linkActive = '-1';
        }
      }
    },
    data() {
      return {
        loginShow: false,
        registerShow: 1,       // 1是登录 2是注册
        isLogin: false,
        browseTime: '',
        imgs: sessionStorage.getItem("imgs"),
        id: sessionStorage.getItem("id"),
        names: sessionStorage.getItem("namess"),
        messageList: [],
        navArr: [
          { id: 0, name: "首页", link: "/" },
          // { id: 1, name: "通知公告", link: "/notice" },
          { id: 1, name: "主题教研", link: "/themeTeacher" },
          { id: 2, name: "专题讲座", link: "/specialZuo" },
          { id: 11, name: "融合教研", link: "/qyjy" },
          { id: 9, name: "名师工作室", link: "/teacher" },
          { id: 15, name: "名校长工作室", link: "/principalforum" },
          { id: 16, name: "零碳工作坊", link: "/zeroCarbon" },
          { id: 3, name: "教材培训", link: "/jiaoPeixun" },
          { id: 4, name: "命题服务", link: "/service" },
          { id: 5, name: "特色课程", link: "/teKecheng" },
          { id: 7, name: "专家团队", link: "/team" },
          { id: 8, name: "基地学校", link: "/school" },
          // { id: 6, name: "优质课展评", link: "/keliShow" },
          { id: 10, name: "学习中心", link: "/studyDo" },
          { id: 16, name: "资源中心", link: "/resourceCenter" },
          //{ id: 13, name: "发展历程", link: "" },
          //{ id: 14, name: "关于我们", link: "" },
        ],
        linkActive: '',
        searchVal: "",
        routerlist: false,
        footerArr: [
          // { id: 1, name: "主题教研 ", link: "/themeTeacher" },
          // { id: 2, name: "专题讲座", link: "/specialZuo" },
          // { id: 3, name: "教材培训", link: "/jiaoPeixun" },
          // { id: 4, name: "命题服务", link: "/service" },
          // { id: 5, name: "特色课程", link: "/teKecheng" },
          // { id: 6, name: "优质课展评", link: "/keliShow" },
          // { id: 7, name: "专家团队", link: "/team" },
          // { id: 8, name: "基地学校", link: "/school" },
          // { id: 9, name: "名师工作室", link: "/teacher" },

          // { id: 10, name: "学习中心", link: "/studyDo" }
        ],
        footerActive: 9,
        userAvatar: '',
        userName: '',
        boxshow: false,
        hideTimeout: null,
        total: 0,
        bqInfo: {
          filings: '',
          mobile: '',
          copyright: '',
          gzh: '',
          xcx: '',
          sph: '',
          email: '',
          history:'',
          aboutus:''
        },
        bannerData: [],
        messageNum: 0
      };
    },
    created() {
      if (getToken()) {
        this.loginChange();
      } else {
        removeToken();
        sessionStorage.removeItem("userId")
        sessionStorage.removeItem("avatar")
        sessionStorage.removeItem("usname")
      }
      getBannerList({ pageNum: 1, pageSize: 8 }).then(response => {
        this.bannerData = response.rows;
      });
      this.setTime()
    },
    methods: {
      loginChange() {
        this.isLogin = true;
        // 确保学习中心在导航栏中
        const studyCenterIndex = this.navArr.findIndex(item => item.name === '学习中心');
        if (studyCenterIndex === -1) {
          this.navArr.splice(12, 0, { id: 10, name: "学习中心", link: "/studyDo" });
        }
        getInfo().then(response => {
          if (!response.user.avatar) {
            response.user.avatar = require('@/assets/images/defaultavatar.png')
            sessionStorage.setItem("noAvatar", response.user.avatar);
          } else {
            sessionStorage.setItem("avatar", response.user.avatar);
          }
          this.userAvatar = response.user.avatar;
          if (response.user.nickName) {
            this.userName = response.user.nickName;
          } else {
            this.userName = response.user.userName;
          }
          sessionStorage.setItem("userId", response.user.userId);
          sessionStorage.setItem("usname", response.user.userName);
          sessionStorage.setItem("nkname", response.user.nickName);
          sessionStorage.setItem("roles", JSON.stringify(response.roles));
          sessionStorage.setItem("permissions", JSON.stringify(response.permissions));
          getTeacherInfo(response.user.userId).then(res => {
            if (res.code == 200 && res.data.teacher) {
              sessionStorage.setItem("tid", res.data.teacher.tid);
              sessionStorage.setItem("truename", res.data.teacher.truename);
              sessionStorage.setItem("subject", res.data.teacher.subjectName);
              sessionStorage.setItem('honour', res.data.teacher.honour)
            } else {
              this.$message.error('管理员禁止登录')
              this.outLogin();
            }
            if (res.data.school) {
              sessionStorage.setItem("sId", res.data.school.sid);
              sessionStorage.setItem("sName", res.data.school.sname);
            }
            if (res.data.isManage) {
              sessionStorage.setItem("isManage", res.data.isManage);
            }
            //屏蔽管理中心
            var manageIndex = -1;
            for (var i = 0; i < this.navArr.length; i++) {
              if (this.navArr[i].name == '管理中心') {
                manageIndex = i;
              }
            }
            if (manageIndex != -1) {
              this.navArr.splice(manageIndex, 1);
            }
            if (res.data.isAudit) {
              sessionStorage.setItem("isAudit", res.data.isAudit);
            }
          })
        });
      },
      getbqInfo() {
        studyApi.allSetInfo().then(res => {
          if (res.code == 200 && res.data.length != 0) {
            res.data.map(item => {
              if (item.configKey == 'filings') {
                this.bqInfo.filings = item.configValue
              }
              if (item.configKey == 'mobile') {
                this.bqInfo.mobile = item.configValue
              }
              if (item.configKey == 'copyright') {
                this.bqInfo.copyright = item.configValue
              }
              if (item.configKey == 'email') {
                this.bqInfo.email = item.configValue
              }
              if (item.configKey == 'gzh') {
                this.bqInfo.gzh = item.configValue
              }
              if (item.configKey == 'xcx') {
                this.bqInfo.xcx = item.configValue
              }
              if (item.configKey == 'sph') {
                this.bqInfo.sph = item.configValue
              }
              if (item.configKey == 'sys.development.history') {
                this.bqInfo.history = item.configValue
              }
              if (item.configKey == 'sys.about.us') {
                this.bqInfo.aboutus = item.configValue
              }
            })
          }
        })
      },
      tolist(item, _index) {
        if (_index == 11) {  // 去学习中心
          if (getToken()) {
            this.linkActive = _index;
            this.$router.push({
              path: item.link
            });
          } else {
            this.$store.commit("LoginFun", true);
          }
        } else {
          this.linkActive = _index;
          this.$router.push({
            path: item.link
          });
        }
      },
      toxxlist() {
        if (getToken()) {
          this.$router.push('/studyMessageList')
        } else {
          this.$store.commit("LoginFun", true);
        }
      },
      // 跳转名校长工作室
      topage(path){
          // this.$message({
          //   message: '功能正在升级...',
          //   type: 'warning'
          // });
          // return
          this.$router.push(path)
          this.linkActive = 5
      },
      todetaillist(item) {
        if (item.readState != 1) {
          const messageId = item.messageId
          studyApi.changeReadState(messageId).then(res => {
            if (item.messageType == 1) {
              const id = item.businessId
              this.$router.push({
                path: '/studyAddActivity',
                query: {
                  id: id,
                  dialogType: 'see'
                }
              })
            } else if (item.messageType == 2) {
              var missionId = item.businessId
              var userMissionId = item.detailId
              this.$router.push({
                path: '/studyAddTask',
                query: {
                  missionId: missionId,
                  userMissionId: userMissionId,
                  dialogType: 'see',
                  // todo: 'do'
                }
              })
              // })
            } else if (item.messageType == 3) {
              // const id = item.businessId
              const moduleType = item.detailType
              if (item.content) {
                if (item.content.indexOf('需要审核') >= 0) {
                  if (item.detailType == 2) {
                    var id = item.detailId
                  } else {
                    var id = item.businessId
                  }
                  this.$router.replace({
                    path: '/studySpDetail',
                    query: {
                      id: id,
                      moduleType: moduleType,
                      dialogType: 'sp',
                    }
                  })
                } else {
                  const id = item.businessId
                  this.$router.replace({
                    path: '/studySpDetail',
                    query: {
                      id: id,
                      moduleType: moduleType,
                      dialogType: 'see',
                    }
                  })
                }
              }
            } else if (item.messageType == 4) {
              var id = item.businessId
              addStudioShenDetail(id).then(response => {
                var groupId = response.data.groupId
                if (item.content) {
                  if (item.content.indexOf('需要审核') >= 0) {
                    this.$router.push({
                      path: '/teacherIndex',
                      query: { id: groupId, type: 'sp', detail: id }
                    })
                  } else {
                    this.$router.push({
                      path: '/teacherIndex',
                      query: { id: groupId, type: 'see', detail: id }
                    })
                  }
                }
              })

            }
          })
        }
      },
      getList() {
        var json = {
          pageNum: this.pageNum,
          pageSize: 5,
          getUserId: sessionStorage.getItem('tid')
        }
        this.messageList = []
        studyApi.messagelist(json).then(response => {
          if (response.rows.length != 0) {
            response.rows.map(item => {
              if (item.readState != 1) {
                this.messageList.push(item)
              }
            })
          }
          this.total = response.total;
        });
      },
      getmsgNum() {
        var getUserId = sessionStorage.getItem('tid')
        studyApi.allmessage(getUserId).then(res => {
          this.messageNum = res.data
        })
      },
      setTime() {
        setInterval(() => {
          this.browseTime++;
          if (sessionStorage.getItem('isId') === 'true') {
            sessionStorage.removeItem('isId');
            window.location.reload();
          }
        }, 1000);
      },
      search() {
        if (!this.$route.path.includes(this.path)) {
          this.$router.push({
            name: "globalSearch",
            query: { key: this.searchVal }
          });
        }
      },
      toMore(index) {
        if (index == 1) {
          var url = "/paperList";
        } else if (index == 2) {
          var url = "/Materials";
        } else if (index == 3) {
          var url = "/ListPapers";
        }
        this.$router.push({
          path: url
        });
      },
      searchEnter(e) {
        this.search();
      },
      // 登录/注册
      login(type) {
        this.registerShow = type;
        // this.loginShow = true;
        this.$store.commit("LoginFun", true);
      },
      homePage() {
        this.$router.push({
          path: "/"
        });
      },
      Jump(item, _index) {
        if (_index == 11) {  // 去学习中心需要登录
          if (getToken()) {
            this.linkActive = _index;
            this.$router.push({
              path: item.link
            });
          } else {
            this.$store.commit("LoginFun", true);
          }
        } else {
          this.linkActive = _index;
            this.$router.push({
              path: item.link
            });
        }

      },
      // 点击关于我们
      toabout() {
        // this.$message({
        //   message: '功能正在升级...',
        //   type: 'warning'
        // });
        // return
        this.$router.push({
          path: "/aboutUs"
        });
      },
      tohistory() {
        // this.$message({
        //   message: '功能正在升级...',
        //   type: 'warning'
        // });
        // return
        this.$router.push({
          path: "/history"
        });
      },
      // 点击个人中心
      toOwn() {
        this.linkActive = 10;
        this.$router.push({
          path: "/studyMySpace"
        });
      },
      // 退出登录
      outLogin() {
        logout().then(res => {
          sessionStorage.clear();
          this.navArr.splice(12, 1);
          this.userAvatar = '';
          this.isLogin = false;
          removeToken();
          this.userName = '';
          this.$router.push({
            path: "/"
          });
          this.routerlist = false
        })
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  >>>.el-header {
    width: 100%;
    height: .9rem !important;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 1999;
  }

  >>>.el-header.bgWhite {
    background: #fff;
    box-shadow: rgb(255 255 255 / 0%) 0px 0px .01rem;
    filter: drop-shadow(rgba(0, 0, 0, 0.15) 0px .03rem .06rem);
  }

  >>>.el-header.bgblack {
    background: rgba(0, 0, 0, .3);
  }

  .navBox {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    padding: 0 0.1rem;
    box-sizing: border-box;
  }

  .navBox li {
    flex-shrink: 1;
    flex-grow: 0;
    flex-basis: auto;
    text-align: center;
  }

  .navBox li span {
    font-weight: 400;
    font-size: 0.17rem;
    color: #333;
    cursor: pointer;
    padding: 0.08rem 0.1rem;
    white-space: nowrap;
  }

  .navBox li.index span {
    color: #fff;
  }

  .navBox li.active span {
    color: #F5772B;
  }

  .loginBox {
    display: flex;
    align-items: center;
    justify-content: end;
  }

  .loginBox .inputBox {
    width: 2rem;
    height: .3rem;
    box-shadow: rgb(255 255 255 / 0%) 0px 0px .01rem;
    box-shadow: 0 .02rem .12rem 0 rgb(0 0 0 / 10%);
  }

  .loginBox>>>.el-input__inner {
    height: .3rem;
    background: #eee;
  }

  .loginBox>>>.el-input__inner:focus {
    border: .01rem solid #DCDFE6;
  }

  .loginBox>>>.el-input__icon {
    line-height: .3rem;
  }

  .loginBox .loginRight {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: .24rem;
    /* line-height: 24px; */
    margin-left: .2rem;
  }

  .loginBox .lingdang {
    font-size: .26rem;
    /* margin-right: 8px; */
    margin-right: .2rem;
    position: relative;
  }

  .lingdang:hover .ownBox1 {
    /* display: block; */
  }

  .loginBox .loginRight.topWhite>div {
    color: #fff;
  }

  >>>.el-footer {
    background: #333;
    height: auto !important;
    padding: .24rem 0px;
  }

  .footer {
    display: flex;
    flex-wrap: wrap;
  }

  .footer .centerContainer {}

  .footer .footerBox {
    display: flex;
    justify-content: space-evenly;
  }

  .footer .footerBox .li {
    color: #fff;
  }

  .footer .footerBox .li:last-child {
    margin-right: 0px;
  }

  .footer .centerContainer .div {
    text-align: center;
    margin-top: .18rem;
  }

  .footer .baiZi {
    color: #fff;
  }

  .footer .huiZi {
    color: #6E6E6E;
  }

  .avatarBox {
    position: relative;
  }

  .avatarBox:hover .ownBox {
    display: block;
  }

  .ownBox {
    display: none;
    position: absolute;
    top: .3rem;
    left: 20%;
    transform: translateX(-50%);
    border-radius: .06rem;
    background: #fff;
    width: 1.2rem;
    box-shadow: rgb(255 255 255 / 0%) 0px 0px .01rem;
    filter: drop-shadow(rgba(0, 0, 0, 0.15) 0px .03rem .06rem);
  }

  .ownBox1 {
    position: fixed !important;
    top: 6% !important;
    left: 80% !important;
    width: 3.1rem !important;
  }

  .ownitem {
    margin-bottom: .06rem;
  }

  .itemtitle {
    width: 100%;
    line-height: .22rem;
    font-size: .14rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis
  }

  .itemtime {
    font-size: .12rem;
    color: rgb(154, 154, 154);
    /* margin-top: 5px; */
  }

  .showmore {
    margin-top: .15rem;
    width: 100%;
    display: flex;
    justify-content: center;
    color: blue;
    font-size: .14rem;
    cursor: pointer;
  }

  .ownBox .ownName {
    text-align: center;
    padding: .2rem 0px;
  }

  .ownList {
    padding: .08rem 0px;
    border-top: .01rem solid #DCDFE6;
    text-align: center;
    font-size: .14rem;
  }

  .ownList:hover {
    background: #F0F0F5;
  }

  .messageNum {
    padding: .02rem .04rem;
    background-color: red;
    /* 红点颜色 */
    border-radius: .1rem;
    /* 红点圆形 */
    position: absolute;
    /* 绝对定位 */
    top: -.02rem;
    /* 距离顶部 */
    right: -.05rem;
    /* 距离右侧 */
    z-index: 10;
    /* 确保位于其他内容之上 */
    color: #fff;
    font-size: .1rem;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }

  .el-icon-arrow-down {
    font-size: .12rem;
  }

  .demonstration {
    display: block;
    color: #8492a6;
    font-size: .14rem;
    margin-bottom: .18rem;
  }

  .topWhite .lingdang {
    color: #fff;
  }
</style>


// WEBPACK FOOTER //
// src/components/HelloWorld.vue